import { object, ref, string } from 'yup';

export const login = object({
  username: string().required().label('نام کاربری'),
  password: string().required().label('رمز عبور'),
  captchaText: string().label('کد امنیتی'),
});

export const AuthorizeUser = object({
  username: string().required().label('نام کاربری'),
  captcha: string().required().label('کد امنیتی'),
});
export const VerifyOtp = object({
  otp: string().required().label('کد یکبارمصرف'),
});
export const RestPassword = object({
  newPassword: string().required().label('رمز عبور جدید'),
  confirmNewPassword: string().required().label(' تکرار رمز عبور جدید')
});

export const changePassword = object({
  currentPassword: string().required().label('رمز عبور فعلی'),
  newPassword: string().required().min(6).label('رمز عبور جدید'),
  newPasswordConfirm: string().min(6).required().label('تکرار رمز عبور جدید')
    .equals([ref('newPassword')], 'تکرار رمز عبور با رمز عبور جدید یکسان نیست'),
});

export const changePasswordCVV2 = object({
  newCvv2: string().required().min(4).max(8).matches(/\d+/i, 'رمز دوم فقط باید از اعداد انگلیسی تشکیل شده باشد').label('روز دوم جدید'),
  confirmNewCvv2: string().min(4).max(8).required().label('تکرار رمز دوم جدید')
    .equals([ref('newCvv2')], 'تکرار رمز دوم با رمز دوم یکسان نیست'),
});
